
import Vue from 'vue'
import { Video } from '@lumiere/db/types'
import { formatTime } from '@lumiere/shared/utils/numberFormatter'
import {
  getVideoThumbnail,
  getAnimatedThumbnail,
} from '@lumiere/shared/utils/getVideoThumbnail'

export default Vue.extend({
  name: 'VideoCard',
  props: {
    video: {
      type: Object as () => Video,
    },
    showTitle: Boolean,
    showDuration: Boolean,
  },
  data() {
    return {
      animatedLoaded: false,
      hovered: false,
    }
  },
  computed: {
    thumbnail(): string | undefined {
      return getVideoThumbnail(this.video)
    },
    liveThumbnail(): string | undefined {
      return getAnimatedThumbnail(this.video)
    },
  },
  filters: {
    formatTime(currentTime: number) {
      return formatTime(currentTime)
    },
  },
  components: {},
})
